module.exports = __webpack_public_path__ + "img/accidentNo.f94f46c6.png";